define("settings/templates/users/remove", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action (perform this.handleClose)}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.users.remove.title" user=this.user.name}} />
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.user}} as |form|>
        <modal.card-body class="u--p__t__0 dd-privacy-mask-user-input">
          <p class="u--m__b__lg">
            {{t "account.users.remove.description"}}
          </p>
          <span class="u--block u--text--bold">
            {{t "shared_words.name"}}
          </span>
          <span class="u--block u--text--md dd-privacy-mask-user-input">
            {{this.user.name}}
          </span>
          <span class="u--block u--text--bold u--p__t__md">
            {{t "shared_words.email"}}
          </span>
          <span class="u--block u--text--md u--m__b dd-privacy-mask-user-input">
            {{this.user.email}}
          </span>
        </modal.card-body>
        <modal.card-footer>
          <form.footer @submitButtonText={{t "account.users.remove.submit"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "Kl2P6tKj",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[28,[37,2],[[30,0,[\"handleClose\"]]],null]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,3],[\"account.users.remove.title\"],[[\"user\"],[[30,0,[\"user\",\"name\"]]]]]]],null],[1,\"\\n    \"],[8,[39,4],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,5],[[30,0,[\"handleSubmit\"]],[30,0,[\"user\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0 dd-privacy-mask-user-input\"]],null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"account.users.remove.description\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--block u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"shared_words.name\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--block u--text--md dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[1,[30,0,[\"user\",\"name\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--block u--text--bold u--p__t__md\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"shared_words.email\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--block u--text--md u--m__b dd-privacy-mask-user-input\"],[12],[1,\"\\n          \"],[1,[30,0,[\"user\",\"email\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,3],[\"account.users.remove.submit\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"action\",\"perform\",\"t\",\"modal-form\",\"task\"]]",
    "moduleName": "settings/templates/users/remove.hbs",
    "isStrictMode": false
  });
});